import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusToast, StatusToastVariant } from '@this+that/ui';
import log from 'loglevel';

import { deleteLocalSnapshots } from './localDraftDeletion';
import { isSnapshotSyncing } from '../../../store/ComposeSnapshotIndex';
import { useCustomToast } from '../../useCustomToast';

const LOG_MESSAGES = {
  DISCARD_FAILED: 'Discarding the local compose failed',
} as const;

export const useDiscardLocalDraft = () => {
  const { t } = useTranslation();
  const { customToaster } = useCustomToast();

  return useCallback(
    async (sessionId: string) => {
      if (isSnapshotSyncing(sessionId)) {
        return;
      }
      try {
        const [snapshot] = await deleteLocalSnapshots([sessionId]);
        if (!snapshot) {
          return;
        }
        customToaster(
          <StatusToast
            status={StatusToastVariant.Success}
            message={t('inbox.userCommunication.localDrafts.discarded')}
            dataTestId="local-draft-discarded-toast"
          />,
        );
      } catch (error) {
        log.warn(LOG_MESSAGES.DISCARD_FAILED, error);
      }
    },
    [customToaster, t],
  );
};
